<template>
  <div id="app">
  	<div class="title-area clear"> 
  		<img class="title-png" src="./assets/top-text.png"/>
  		<div class="left-title-area">
  			<div class="left-top-text">
  				<span class="label-text">组织：</span><img height="40" width="336" src="./assets/to-right-text.png"/>
  				<p class="text-po" @click="showConfirm = 'org'">{{defaultOrg}} <img height="14" width="24" src="./assets/arrow.png"/></p> 
  			</div>
  			<div class="left-bottom-text">
  				<img height="31" width="432" src="./assets/sm-to-right-text.png"/>
  				<p class="text-posi"><span>数据来自: </span>{{content}}</p>  
  			</div>
  		</div>
  		<div class="center-title-area">
  			<p class="center-title">{{getName}}</p>
  			<p class="center-weather"><span v-html="time"></span><span v-html="weatherinfo.time">08:18:00</span><span v-html="weatherinfo.WD + '(' + weatherinfo.WSE + ')'">23℃</span></p>
  		</div>
  		<div class="right-title-area">
  			<div class="right-top-text">
  				<img width="432" height="84" src="./assets/to-left-text.png"/>
  				<div class="right-po clear">
  					<div class="right-po-text clear">
  						<div class="item-text" v-for="item in infoList" :key="item">
  							<span v-html="item.typeName"></span>{{item.unitPrice + item.company}}
  						</div>
  					</div>
  					<div class="right1-po-text">
  						<div @click="showConfirm = 'pro'">
  							<img class="map" width="13" height="14" src="./assets/map.png"/>{{defaultProvince}}
  						</div>
  						<div @click="showDetail">
  							详情<img class="detail" width="19" height="11" src="./assets/sm-arrow.png"/>
  						</div>
  					</div>
  				</div>
  			</div>
  		</div>
  	</div>
  	<div class="bk-screen" v-show="showConfirm">
  		<div :class="['bk-screen-body',{'province': showConfirm == 'pro','organization': showConfirm == 'org','detail': showConfirm == 'detail'}]" v-show="showConfirm">
  			<span></span>
  			<span></span>
  			<span></span>
  			<span></span>
  			<div class="province-box" v-if="showConfirm == 'pro'">
  				<div :key="item" v-for="item in provinceList" v-html="item" :class="['province-text',{'active': item == defaultProvince}]" @click="chooseProvinceAndGetInfo(item)"></div>
  			</div>
  			<div class="province-box" v-if="showConfirm == 'org'">
  				<el-tree :data="orgList" :props="defaultProps" :expand-on-click-node="false" node-key="id" :accordion="true" @current-change="currentChange"></el-tree>
  			</div>
  			<div id="detailmap" v-if="showConfirm == 'detail'"></div>
  		</div>
  	</div>
  	<router-view class="area-body" :orgid="defaultOrgId"></router-view>
  </div>
</template>

<script>
import moment from "moment";
import { mapState,mapGetters } from "vuex";
import echarts from "../static/js/echart_init.js";
import { Tree } from "element-ui";
import myVue from "./js/emit.js";
import BMap from 'BMap'
export default {
  name: 'App',
  data(){
  	return {
  		time: moment().format("YYYY-MM-DD"), // 时间
  		weatherinfo: {}, // 天气信息
  		infoList: [], // 行情列表
  		provinceList: [], // 省份列表
  		orgList: [], // 组织列表
    	defaultProps: {
      	children: 'children',
      	label: 'text'
    	},
    	showConfirm: false, // 是否显示弹框: 'pro'省份 ,'org'组织  
    	content: "", // 数据来源
    	defaultOrg: "", // 默认组织
    	defaultOrgId: null, // 默认组织ID
    	defaultProvince: "湖南省"
  	}
  },
  computed:{
  	...mapGetters([ 
  		'getName'
  	])
  },
  components: {
  	elTree: Tree
  },
  methods: {
    city(){    //定义获取城市方法
        const geolocation = new BMap.Geolocation();
        var _this = this
        geolocation.getCurrentPosition(function getinfo(position){
            console.log(position.address.province)
            let city = position.address.city;             //获取城市信息
            let province = position.address.province;    //获取省份信息
            _this.defaultProvince = province
        }, function(e) {
            _this.defaultProvince = "湖南省"
        }, {provider: 'baidu'});    
    },
  	toIndex(){
  		this.$router.push("/");
  	},
  	showDetail(){
  		this.showConfirm = 'detail';
  		this.$http({
  			url: "/homePage/marketinformation/getQuotationChartData.act",
  			params: {province: this.defaultProvince}
  		}).then(res => {
  			if(res.data.statusCode == '200'){
  				this.initDetail(res.data.content);
  			}
  		})
  	},
  	initDetail(data){
  		var myChart = echarts.init(document.getElementById('detailmap'),'dark');
  		var option = {
				    title: {
				      text: '价格',
				      subtext: "备注: 生猪丶仔猪(元/公斤) , 玉米丶豆粕(元/吨)",
				      subtextStyle: {
				      	color: "#fff",
				      	align: 'center',
				      	width: '100%'
				      }
				    },
				    tooltip: {
				      trigger: 'axis',
				    },
				    legend: {
				      data:['生猪','仔猪','玉米','豆粕']
				    },
				    grid: {
			        left: '5%',
			        right: '5%',
			        bottom: '2%',
			        top: '15%',
			        containLabel: true
				    },
				    xAxis: {
			        type: 'category',
			        boundaryGap: false,
			        data: data.timeRange
				    },
				    yAxis: {
				        type: 'value'
				    },
				    series: [
			        {
		            name: '生猪',
		            type: 'line',
		            data: data.swineData
			        },
			        {
		            name: '仔猪',
		            type: 'line',
		            tooltip: {
		            	formatter: '{b0}: {c0}<br />{b1}: {c1}'
		            },
		            data: data.pigletData
			        },
			        {
		            name: '玉米',
		            type: 'line',
		            tooltip: {
		            	formatter: '{b0}: {c0}<br />{b1}: {c1}'
		            },
		            data: data.cornData
			        },
			        {
		            name: '豆粕',
		            type: 'line',
		            tooltip: {
		            	formatter: '{b0}: {c0}<br />{b1}: {c1}'
		            },
		            data: data.SBMData
			        }
				    ]
					};
				myChart.setOption(option);
  	},
  	getWeather(){
  		this.$http({
  			url: ""
  		}).then(res => {
  			if(res.data.statusCode == '200'){
  				this.weatherinfo = res.data.weatherinfo;
  			}
  		})
  	},
  	// 获取行情信息
  	async getInfo(){
  		await	this.$http({
			  			url: "",
			  		}).then(res => {
			  			if(res.data.statusCode == '200'){
			  				this.infoList = res.data.getMarketInformation.dataList;
			  			}
			  		})
  	},
  	chooseProvinceAndGetInfo(e){
  		if(e == this.defaultProvince) return;
  		this.defaultProvince = e;
  		this.getInfo().then(res => {
  			this.showConfirm = false;
  		})
  	},
  	// 获取省份
  	getProvince(){
  		this.$http({
  			url: ""
  		}).then(res => {
  			if(res.data.statusCode == '200'){
					this.provinceList = res.data.getProvinces;
  			}
  		})
  	},
  	// 获取组织
  	getOrginization(){
  		this.$http({
  			url: ""
  		}).then(res => {
  			var data = res.data;
  			if(data.statusCode == 200){
					this.orgList = data.getOrganization;
					this.getDefaultOrg(data.getOrganization[0]);
  			}
  		})
  	},
  	// 获取默认组织信息
  	async getDefaultOrg(item){
  		await this.$http({
			  			url: "",
			  		}).then(res => {
			  			var data = res.data;
			  			if(data.statusCode == 200){
								this.content = data.setOrganization;
								this.defaultOrgId = item.id;
  							this.defaultOrg = item.text;
			  			}
			  		})
  	},
  	currentChange(e){
  		if(e.id == this.defaultOrgId) return;
  		this.getDefaultOrg(e).then(val => {
  			this.showConfirm = false;
  			myVue.emit("changeOrg");
  		});
  	}
  },
  mounted(){
    this.city();
  	this.getWeather();
  	this.getInfo();
  	this.getProvince();
  	this.getOrginization();
  	document.addEventListener("click", (e) => {
  		var obj = document.querySelector(".bk-screen-body");
  		if(e.target.contains(obj)){
  			this.showConfirm = false;
  		}
  	})
  }
}
</script>
<style src="./css/base.css"></style>
<style src="./css/common.scss" lang="scss"></style>
<style src="./css/app.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue